import React from 'react';
import Slider from 'react-slick';
import { Text } from 'pp-react';

import * as analytics from '../lib/analytics';

import { SampleNextArrow, SamplePrevArrow } from './arrows';

import content from '../lib/i18n';
const i18n = content('hub/components/categoryTiles');

export default class extends React.Component {
  static defaultProps = {};

  state = {
    isMobile: false,
  };

  handleCategoryClick = category => {
    location.href = `${this.props.coBrand}hub?category=${category}`;

    analytics.trackLinkWithData(
      'CategoryTile',
      this.props.fptiInfo.pgrp,
      this.props.fptiInfo.page,
      { category: category },
      'link'
    );
  };

  componentDidMount() {
    if (/Android|webOS|iPhone|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.setState({
        isMobile: true,
      });
    }
  }

  renderCategory = () => {
    const categoryTiles = this.props.categories || [];

    return categoryTiles.map((category, index) => {
      const categoryName = i18n(`label.category-${category.id}`);
      return (
        <div
          className='col-xs-6 col-sm-6 col-md-4 col-lg-4'
          key={index}
          onClick={this.handleCategoryClick.bind(this, category.name)}
        >
          <div
            className={'cardCategoryTiles'}
            style={{
              background:
                'linear-gradient(rgba(0,0,0,0.15), rgba(0,0,0,0.0)), url(' +
                category.imgURL +
                ') no-repeat',
              backgroundSize: 'cover',
            }}
          >
            <div className={'cardCategoryContent'}>
              <p className={'categoryName'}>{categoryName}</p>
            </div>
          </div>
        </div>
      );
    });
  };

  renderCarouselPanes = () => {
    let settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
    };

    let categoryPane = [],
      size = 9;

    if (this.state.isMobile) {
      size = 6;
    }

    let renderedCharity = this.renderCategory();

    while (renderedCharity.length > 0) {
      categoryPane.push(renderedCharity.splice(0, size));
    }

    let categoryResp = categoryPane.map((result, index) => {
      return <div key={index}>{result}</div>;
    });

    return <Slider {...settings}>{categoryResp}</Slider>;
  };

  render() {
    return (
      <div className={'cards row'}>
        <Text as='h3' size='xl3' className={'card_heading'}>
          {i18n('label.browse-categories')}
        </Text>
        {this.renderCarouselPanes()}
      </div>
    );
  }
}
